import { Form, FormField, IFormField, RequiredValidator } from '@thinknimble/tn-forms'
import i18next from '../../i18n/config'
import { SelectOption } from '../base-model'

const { t } = i18next

export type ReportFields = {
  _name: IFormField<string>
  notes: IFormField<string>
  organization: IFormField<SelectOption | undefined>
  defaultTemplate: IFormField<SelectOption | undefined>
}

export class ReportForm extends Form<ReportFields> {
  static _name = new FormField({
    label: t('reportForm.nameLabel'),
    placeholder: t('reportForm.namePlaceholder'),
    validators: [new RequiredValidator()],
  })

  static notes = new FormField({
    label: t('reportForm.notesLabel'),
    placeholder: t('reportForm.notesPlaceholder'),
    validators: [],
  })

  static organization = new FormField({
    label: t('reportForm.organizationLabel'),
    placeholder: t('reportForm.organizationPlaceholder'),
    validators: [new RequiredValidator()],
  })

  static defaultTemplate = new FormField({
    label: 'Default Export Template',
    placeholder: 'Select a template (optional)',
    validators: [],
  })

  get val() {
    return {
      name: this.field._name.value,
      notes: this.field.notes.value,
      organization: this.field?.organization?.value?.value,
      defaultTemplate: this.field?.defaultTemplate?.value?.value || null,
    }
  }
}

// Example usage with TReportForm
export type TReportForm = ReportForm & ReportFields
